<template>
    <div v-if="license" class="user-sites-box box">
        <div class="box-title">
            Your Sites
            <div v-if="pageLimit < license.websites.length" class="filters">
                <div class="filter-checkboxes">
                    <div
                        v-for="( filterControl ) in filterControls"
                        :key="filterControl.filter"
                        class="checkbox-wrap"
                    >
                        <template
                            v-if="('excessive' !== filterControl.filter)
                                ? true
                                : hasExcessiveSites"
                        >
                            <input
                                v-model="statusFilters"
                                :class="`is-${filterControl.color}`"
                                type="checkbox"
                                :value="filterControl.filter"
                                @change="pageNum = 1"
                            >
                            <label>{{ filterControl.label }}</label>
                        </template>
                    </div>
                </div><!-- .filter-checkboxes -->
                <div
                    :class="[
                        {'is-empty': '' === searchPhrase},
                        'search-form'
                    ]"
                >
                    <input
                        v-model="searchPhrase"
                        class="search-phrase is-small"
                        type="text"
                        placeholder="Search domain..."
                        @change="pageNum = 1"
                    >
                    <span
                        v-if="'' !== searchPhrase"
                        class="clear-search"
                        @click="searchPhrase = ''"
                    >
                        <i class="fal fa-times-circle" />
                    </span>
                </div><!-- .search-form -->
            </div><!-- .filters -->
        </div><!-- .box-title -->
        <div class="box-content">
            <div
                v-if="!isLifetimeSubscriptionSelected && 0 < sites.length"
                class="list-controls"
            >
                <div
                    :style="{
                        'opacity': (0 === siteIds.length) ? 0 : 1,
                        'visibility': ( 0 === siteIds.length) ? 'hidden' : 'visible'
                    }"
                    class="bulk-action"
                    @click="openModal"
                >
                    <div class="tooltip">
                        Deactivate Selected Sites
                    </div>
                    <i class="fal fa-unlink site-icon bulk-icon" />
                </div>
                <div
                    v-for="control in sortControls"
                    :key="control.sortType"
                    :class="`site-${control.type}`"
                >
                    <span @click="sortBy = control.type">{{ control.label }}</span>
                    <i
                        v-show="sortBy === control.type"
                        :class="[
                            reverseResults[control.type]
                                ? 'fa-caret-up'
                                : 'fa-caret-down',
                                'fas sort-icon'
                        ]"
                        @click="reverseResults[control.type] = !reverseResults[control.type]"
                    />
                </div>
            </div><!-- .list-controls -->
            <transition-group
                name="fade"
                mode="out-in"
            >
                <ul
                    v-if="0 < sites.length"
                    key="sites-listing"
                    class="sites-listing"
                >
                    <li
                        v-for="( site, index ) in sites"
                        :key="site.id"
                        :class="[
                            {'is-excessive': 'excessive' === site.status},
                            {'is-lifetime': isLifetimeSubscriptionSelected},
                            'site-item flex'
                        ]"
                    >
                        <div class="site-url">
                            <template v-if="('excessive' === site.status) || isLifetimeSubscriptionSelected">
                                <i
                                    :class="[
                                        'excessive' === site.status
                                            ? 'fa-exclamation-circle'
                                            : 'fa-browser lifetime-icon',
                                        'fal'
                                    ]"
                                />
                            </template>
                            <template v-else>
                                <div
                                    :class="[
                                        { 'is-hidden': 'inactive' === site.status },
                                        'checkbox-wrap'
                                    ]"
                                >
                                    <input
                                        v-model="siteIds"
                                        type="checkbox"
                                        :value="site.id"
                                    >
                                    <label />
                                </div>
                            </template>
                            <span
                                :class="[
                                    {'is-search': '' !== searchPhrase },
                                    'site-domain'
                                ]"
                            >
                                <template v-if="'' === searchPhrase">
                                    {{ trimEnd( site.home, '/' ) }}
                                </template>
                                <template v-else>
                                   <!-- eslint-disable-next-line vue/no-v-html -->
                                   <span v-html="highlightSearchResults(site.home)" />
                                </template>
                            </span>
                        </div><!-- .site-url -->
                        <template v-if="!isLifetimeSubscriptionSelected">
                            <website-label
                                :key="index"
                                :site="site"
                            />
                            <div
                                class="site-date"
                            >
                                {{ formatedDate (site.created_at) }}
                            </div>
                        </template>
                        <span
                            v-if="'inactive' !== site.status"
                            class="site-action"
                            @click="openModal(site)"
                        >
                            <div class="tooltip">
                                Deactivate Site
                            </div>
                            <i class="fal fa-unlink deactivate" />
                        </span>
                    </li><!-- .site-item -->
                </ul><!-- .sites-listing -->
                <div
                    v-else
                    key="no-sites-message"
                    class="no-sites-message"
                >
                    You don't have any websites yet
                </div>
                <div
                    v-if="0 < sites.length"
                    key="sites-controls"
                    class="sites-controls"
                >
                    <button
                        v-if="showMoreSitesbutton"
                        class="btn"
                        @click="openUpgradeModal"
                    >
                        <i class="far fa-plus" />Add More Sites to Your Plan
                    </button>
                    <template
                        v-if="license.websites.length > pageLimit"
                    >
                        <paginate
                            v-model="pageNum"
                            :page-count="totalPages"
                            :click-handler="setPageNumber"
                            :prev-text="''"
                            :next-text="''"
                            :class="[{ 'has-navigation': paginationShowNav } ,'pagination']"
                            :active-class="'is-active'"
                            :prev-link-class="'pagination-arrow pagination-prev'"
                            :next-link-class="'pagination-arrow pagination-next'"
                            :hide-prev-next="paginationShowNav"
                            :first-last-button="paginationShowNav"
                            :first-button-text="''"
                            :last-button-text="''"
                            :break-view-class="'pagination-decorator'"
                        />
                    </template>
                </div><!-- .sites-controls -->
            </transition-group>
        </div><!-- .box-content -->
        <transition
            name="fade"
        >
            <deactivate-site-modal
                v-if="UIState.isDeactivateSiteModalVisible"
                :site-ids="siteIds"
                :site-to-deactivate="siteToDeactivate"
                @modal-closed="clearData"
            />
        </transition>
    </div><!-- .user-sites-box -->
</template>

<script>
import { mapState, mapMutations, mapGetters } from 'vuex';
import toasts from '@/mixins/toasts';
import { trimEnd, slice, capitalize, sortBy } from 'lodash';
import moment from 'moment';

import DeactivateSiteModal from './DeactivateSiteModal.vue';
import WebsiteLabel from './WebsiteLabel.vue';
import Paginate from 'vuejs-paginate';

export default {
    components: {
        DeactivateSiteModal,
        WebsiteLabel,
        Paginate,
    },

    mixins: [toasts],

    props: {
        license: {
            type: Object,
            default: null,
        },
    },

    data: () => ({
        pageNum: 1,
        pageLimit: 10,
        websitesCount: 0,
        siteIds: [],
        siteToDeactivate: {},
        statusFilters: [],
        sortBy: 'url',
        hasExcessiveSites: false,
        reverseResults: {
            url: false,
            status: false,
            date: false,
        },
        searchPhrase: '',
        filterControls: [
            {
                filter: 'active',
                label: 'live',
                color: 'green',
            },
            {
                filter: 'dev',
                label: 'staging',
                color: 'purple',
            },
            {
                filter: 'inactive',
                label: 'inactive',
                color: 'red',
            },
            {
                filter: 'excessive',
                label: 'excessive',
                color: 'red',
            },
        ],
        sortControls: [
            {
                type: 'url',
                label: 'Domain Names',
            },
            {
                type: 'status',
                label: 'Site status',
            },
            {
                type: 'date',
                label: 'Date Added',
            },
        ],
    }),

    computed: {
        ...mapState(['UIState']),
        ...mapGetters(['userSubscriptionDetails', 'isLifetimeSubscriptionSelected']),

        /**
         * @returns {boolean} Whether to show the Add More Sites button.
         */
        showMoreSitesbutton() {
            return ! this.userSubscriptionDetails.endsAt && ! this.isLifetimeSubscriptionSelected;
        },

        /**
         * @returns {Array} Filtered, sorted and paginated websites
         */
        sites() {
            if (0 === this.statusFilters.length) {
                return [];
            }

            let websites = this.applyFilters(this.license.websites);

            this.setNumberOfWebsites(websites.length);

            websites = this.sortWebsites(websites);

            const offset = (this.pageNum - 1) * this.pageLimit;

            return slice(websites, offset, this.pageLimit * this.pageNum);
        },

        /**
         * @returns {number} Total number of pages
         */
        totalPages() {
            return Math.ceil(this.websitesCount / this.pageLimit);
        },

        /**
         * Pagination arrow navigation display control
         *
         * @returns {boolean} Whether show prev/next buttons
         */
        paginationShowNav() {
            return 3 < this.totalPages;
        },
    },

    watch: {
        license: {
            immediate: true,

            /**
             * Set status filters and watch for license change
             *
             * @param {object} newLicense License object.
             */
            handler(newLicense) {
                const filters = new Set();

                for (const website of this.license.websites) {
                    filters.add(website.status);
                }

                this.hasExcessiveSites = filters.has('excessive');
                this.statusFilters = Array.from(filters);
            },
        },
    },

    methods: {
        ...mapMutations(['changeUIState']),

        trimEnd,

        /**
         * Set number of websites
         *
         * @param {number} number Number of websites
         */
        setNumberOfWebsites(number) {
            this.websitesCount = number;
        },

        /**
         * Opens deactivate modal
         *
         * @param {object} site Site data.
         */
        openModal(site) {
            if (site.id) {
                this.siteIds = [];
                this.siteToDeactivate = site;
            } else {
                this.siteToDeactivate = {};
            }

            this.changeUIState({ isDeactivateSiteModalVisible: true });
        },

        /**
         * Opens upgrade modal
         */
        openUpgradeModal() {
            this.changeUIState({ isUpgradeProModalVisible: true });
        },

        /**
         * Return formated date
         *
         * @param {string} date Date in ISO 8601 format
         * @returns {string} Formated date
         */
        formatedDate(date) {
            return moment(date).format('MMM D, YYYY');
        },

        /**
         * Clears site data and checkboxes after sites deactivation
         */
        clearData() {
            this.siteIds = [];
            this.siteToDeactivate = {};
            this.pageNum = 1;
        },

        /**
         * Filter websites by status
         *
         * @param {Array} websites License websites.
         * @returns {Array} Filtered websites array.
         */
        filterByStatus(websites) {
            let filteredWebsites = [];

            for (const filter of this.statusFilters) {
                filteredWebsites = [...filteredWebsites, ...websites.filter(
                    website => website.status === filter
                )];
            }

            this.setNumberOfWebsites(filteredWebsites.length);

            return filteredWebsites;
        },

        /**
         * Filter websites by given phrase
         *
         * @param {Array} websites User websites
         * @returns {Array} Search results
         */
        filterByPhrase(websites) {
            return websites.filter(website => website.home.includes(this.searchPhrase));
        },

        /**
         * Filter websites for lifetime licenses
         *
         * @param {Array} websites User websites.
         * @returns {Array} Filtered lifetime websites.
         */
        filterLifetimeWebsites(websites) {
            return websites.filter(website => 'inactive' !== website.status);
        },

        /**
         * Sort websites by domain name
         *
         * @param {Array} websites User websites
         * @returns {Array} sorted websites
         */
        sortByUrl(websites) {
            return sortBy(websites, website => website.home);
        },

        /**
         * Sort websites by status
         *
         * @param {Array} websites User websites
         * @returns {Array} sorted websites
         */
        sortByStatus(websites) {
            return sortBy(websites, website => website.status);
        },

        /**
         * Sort websites by created date
         *
         * @param {Array} websites User websites
         * @returns {Array} sorted websites
         */
        sortByDate(websites) {
            return sortBy(websites, website => moment(website.created_at).format('YYYYMMDD'));
        },

        /**
         * Highlight search phrase
         *
         * @param {string} string String to highlight
         * @returns {string} Higlighted string
         */
        highlightSearchResults(string) {
            return trimEnd(string, '/')
                .replace(this.searchPhrase, `<span class="highlight">${this.searchPhrase}</span>`);
        },

        /**
         * Apply filters based on settings
         *
         * @param {Array} websites License websites.
         * @returns {Array} Filtered websites.
         */
        applyFilters(websites) {
            let filteredWebsites = this.filterByStatus(websites);

            if ('' !== this.searchPhrase) {
                filteredWebsites = this.filterByPhrase(filteredWebsites);
            }

            if (this.isLifetimeSubscriptionSelected) {
                filteredWebsites = this.filterLifetimeWebsites(filteredWebsites);
            }

            return filteredWebsites;
        },

        /**
         * Sort websites
         *
         * @param {Array} websites License websites.
         * @returns {Array} Sorted websites.
         */
        sortWebsites(websites) {
            let sortedWebsites = this[`sortBy${capitalize(this.sortBy)}`](websites);

            if (this.reverseResults[this.sortBy]) {
                sortedWebsites = sortedWebsites.reverse();
            }

            return sortedWebsites;
        },

        /**
         * Sets page number
         *
         * @param {number} number Page number
         */
        setPageNumber(number) {
            this.pageNum = number;
        },
    },
};
</script>
